import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";
import { useRef } from "react";

import { $gitBranches } from "../../internal/git";

/**
 * Hook to access git branches
 * @param documentId - The document ID
 * @returns List of branches
 */
export const useGitBranches = (documentId: string | undefined) => {
	const branchesAtom = $gitBranches(documentId);
	const branchesLoadable = useAtomValue(loadable(branchesAtom));
	const refresh = useSetAtom(branchesAtom);

	// Keep track of the last successful data to avoid flickering while loading
	const lastDataRef = useRef(branchesLoadable.state === "hasData" ? branchesLoadable.data : []);

	// Update the ref when we have new data
	if (branchesLoadable.state === "hasData") {
		lastDataRef.current = branchesLoadable.data;
	}

	return {
		// Return last successful data while loading (stale-while-revalidate)
		branches:
			branchesLoadable.state === "hasData" ? branchesLoadable.data : lastDataRef.current,
		refresh,
		isLoading: branchesLoadable.state === "loading",
		isError: branchesLoadable.state === "hasError",
	};
};
